module.exports = "/_next/static/images/8c65bea4e29cca81bd187484938c6d37-filter-purple.svg";